import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PinnedMessageItem } from '../../components/chat/ChatListMenu';

export const pinnedMessageFocusSlice = createSlice({
	name: 'pinnedMessageFocus',
	initialState: null as PinnedMessageItem | null,
	reducers: {
		setPinnedMessageInFocus: (_state, action: PayloadAction<PinnedMessageItem | null>) => action.payload,
	},
});
